export default function initAudioPlayer() {

    const audio = document.getElementById('Podcast');
    if (!audio) return;

    // --- HLS INIT ---
    const hlsUrl = audio.getAttribute('data-src'); // Usa un attributo HTML <audio id="Podcast" data-src="...">
    audio.removeAttribute('src'); // Eviti conflitti

    function setupHLS() {

        // CASE 1: CHROME / FIREFOX / EDGE → usare hls.js
        if (window.Hls && Hls.isSupported()) {
            const hls = new Hls({
                enableWorker: true,
                lowLatencyMode: true
            });

            hls.loadSource(hlsUrl);
            hls.attachMedia(audio);

            // Aspetto che manifest e media siano pronti
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                console.log("[HLS] Manifest parsed, HLS ready");
            });

            hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                console.log("[HLS] Media attached");
            });

            hls.on(Hls.Events.ERROR, function (event, data) {
                console.error("HLS ERROR:", data);
            });

            return;
        }

        // CASE 2: SAFARI (nativo)
        if (audio.canPlayType("application/vnd.apple.mpegurl")) {
            audio.src = hlsUrl;

            // Aspetto metadata altrimenti safari abortisce play()
            audio.addEventListener("loadedmetadata", () => {
                console.log("[SAFARI] Metadata loaded, audio ready");
            });

            return;
        }

        // CASE 3: fallback (vecchi browser)
        if (window.Hls) {
            const hls = new Hls();
            hls.loadSource(hlsUrl);
            hls.attachMedia(audio);
        }
    }


    setupHLS();
    // --- END HLS INIT ---


    const playPauseBtn = document.querySelector(".AudioBox__Controls-Play");
    playPauseBtn.classList.add("is-paused");
    const forwardBtn = document.querySelector(".AudioBox__Controls-Next");
    const backwardBtn = document.querySelector(".AudioBox__Controls-Prev");
    const progressBar = document.querySelector(".AudioBox__ProgressBar span");
    const durationDisplay = document.querySelector(".AudioBox__duration");
    const shareBox = document.querySelector(".AudioBox__share");
    const shareToggleBtn = document.querySelector(".AudioBox__option");
    const shareCloseBtn = document.querySelector("#AudioBox__share--close");
    const copyLinkBtn = document.querySelector(".CopyLink");

    //let totalDuration = audio.duration;
    let totalDuration = NaN;

    // Funzione per aggiornare il tempo rimanente
    function updateDurationDisplay() {
        if (!totalDuration || isNaN(totalDuration)) {
            durationDisplay.textContent = "--:--";
            return;
        }

        const remainingTime = totalDuration - audio.currentTime;

        if (remainingTime < 0 || isNaN(remainingTime)) {
            durationDisplay.textContent = "--:--";
            return;
        }

        const formattedTime = new Date(remainingTime * 1000)
            .toISOString()
            .substr(11, 8);

        durationDisplay.textContent = formattedTime;
    }

    audio.addEventListener("loadedmetadata", function () {
        if (!isNaN(audio.duration)) {
            totalDuration = audio.duration;
        }
        updateDurationDisplay();
    });

    // Play/Pause
    /*playPauseBtn.addEventListener("click", function () {
        if (audio.paused) {
            audio.play();
            playPauseBtn.classList.add("playing"); // Classe CSS per mostrare il pulsante in stato "play"
        } else {
            audio.pause();
            playPauseBtn.classList.remove("playing");
        }
    });*/
    playPauseBtn.addEventListener("click", async function () {
        try {
            if (audio.paused) {
                await audio.play();
                playPauseBtn.classList.remove("is-paused");
                playPauseBtn.classList.add("is-playing");
            } else {
                audio.pause();
                playPauseBtn.classList.remove("is-playing");
                playPauseBtn.classList.add("is-paused");
            }
        } catch (err) {
            console.warn("Play prevented:", err);
        }
    });

    // Skip avanti di 15s
    forwardBtn.addEventListener("click", function () {
        audio.currentTime = Math.min(audio.currentTime + 15, totalDuration);
    });

    // Skip indietro di 15s
    backwardBtn.addEventListener("click", function () {
        audio.currentTime = Math.max(audio.currentTime - 15, 0);
    });

    // Aggiornare la barra di progresso
    audio.addEventListener("timeupdate", function () {
        if (!totalDuration || isNaN(totalDuration)) {
            if (!isNaN(audio.duration)) {
                totalDuration = audio.duration;
            }
        }

        const progressPercentage = (audio.currentTime / totalDuration) * 100;
        progressBar.style.width = `${progressPercentage}%`;
        updateDurationDisplay();
    });

    // Click sulla barra per cambiare posizione
    document.querySelector(".AudioBox__ProgressBar").addEventListener("click", function (event) {
        const progressBarWidth = this.offsetWidth;
        const clickPosition = event.offsetX;
        const newTime = (clickPosition / progressBarWidth) * totalDuration;
        audio.currentTime = newTime;
    });

    // Aggiornare il tempo rimanente al caricamento dei metadata
    audio.addEventListener("loadedmetadata", function () {
        totalDuration = audio.duration;
        updateDurationDisplay();
    });

    // Resettare la barra di progresso e la durata alla fine
    audio.addEventListener("ended", function () {
        progressBar.style.width = "0%";
        audio.currentTime = 0;
        durationDisplay.textContent = new Date(totalDuration * 1000).toISOString().slice(11, 19);
        playPauseBtn.classList.remove("playing");
    });

    // Mostrare la finestra di condivisione con effetto zoom in
    shareToggleBtn.addEventListener("click", function () {
        shareBox.classList.remove("d-none");
        shareBox.style.animation = "zoomIn 0.3s ease forwards";
    });

    // Chiudere la finestra di condivisione
    shareCloseBtn.addEventListener("click", function () {
        shareBox.style.animation = "zoomOut 0.3s ease forwards";
        setTimeout(() => {
            shareBox.classList.add("d-none");
        }, 300);
    });

    copyLinkBtn.addEventListener("click", function (event) {
        event.preventDefault();
        navigator.clipboard.writeText(window.location.href).then(() => {
            const feedback = document.createElement("span");
            feedback.innerHTML = "<i class=\"fa-solid fa-check-double\"></i> Copied!";
            feedback.classList.add("copy-feedback");
            copyLinkBtn.appendChild(feedback);
            setTimeout(() => feedback.remove(), 2000);
        }).catch(err => console.error("Errore nella copia del link", err));
    });
}